"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasShowButtonSelector = exports.hasSimplifyTabsSelector = void 0;

var hasSimplifyTabsSelector = function hasSimplifyTabsSelector(state) {
  var Wp006simplifyTabs = state.Wp006simplifyTabs;
  return Wp006simplifyTabs.showSimplifyTabs;
};

exports.hasSimplifyTabsSelector = hasSimplifyTabsSelector;

var hasShowButtonSelector = function hasShowButtonSelector(state) {
  var Wp006simplifyTabs = state.Wp006simplifyTabs;
  return Wp006simplifyTabs.showButton;
};

exports.hasShowButtonSelector = hasShowButtonSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/Wp006Selectors.js
// module id = 433
// module chunks = 5 6